<template>
  <div>
    <v-row>
      <v-col align-self="center"
        ><strong>{{ group.title }}</strong></v-col
      >
      <v-col v-if="years.length" md="4" xs="12">
        <v-select
          v-model="currentYear"
          :items="years"
          label="год"
          class="mb-2"
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <div>
      <div v-for="item in results" :key="item.title" class="line">
        <option-row
          ><span slot="title">{{ item.title }}: </span
          >{{ item.score }}</option-row
        >
        <div v-if="item.updatedAt" class="text-caption">
          <option-row title="Баллы обновлены:"
            ><span>{{ item.updatedAt }}</span></option-row
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoreYearTab",
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentYear: undefined,
    };
  },

  computed: {
    years() {
      const years = new Set();
      Object.values(this.group.competences).forEach((n) => {
        Object.keys(n.results).forEach((year) => {
          years.add(year);
        });
      });
      return [...years].sort((a, b) => b - a);
    },
    results() {
      return Object.values(this.group.competences)
        .filter((n) => {
          return this.currentYear in n.results;
        })
        .map(({ results, ...item }) => {
          return {
            ...item,
            score: results[this.currentYear]?.score,
            updatedAt: results[this.currentYear]?.updatedAt,
          };
        });
    },
  },

  created() {
    if (this.years.length) {
      this.currentYear = this.years[0];
    }
  },
};
</script>

<style lang="scss" scoped>
.line {
  & + & {
    margin-top: 10px;
  }
}
</style>
